import { render, staticRenderFns } from "./EditCampaign.vue?vue&type=template&id=5995ebfa&scoped=true"
import script from "./EditCampaign.vue?vue&type=script&lang=ts"
export * from "./EditCampaign.vue?vue&type=script&lang=ts"
import style0 from "./EditCampaign.vue?vue&type=style&index=0&id=5995ebfa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995ebfa",
  null
  
)

export default component.exports